import Vue from 'vue';
import config from '@/config/index';
export default {
    //列表页相关
    // 查询
    getDeviceSeriesPage(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/page`,
            method: 'get',
            params
        })
    },
    // 新增设备系列
    addDeviceSeries(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/add`,
            method: 'post',
            data
        })
    },
    // 查询设备系列详情
    getDeviceSeriesDetail(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/detail`,
            method: 'get',
            params
        })
    },
    // 查询设备品牌下的设备系列
    getDeviceSeriesByBrand(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/list`,
            method: 'get',
            params
        })
    }
}